// extracted by mini-css-extract-plugin
export default {"Calendar":"PsPU-","Calendar--hasTime":"T163R","Calendar--withoutMonthsNavigation":"JqW0p","Calendar--isMobile":"yMKNJ","skeleton-progress":"hRQLG"};